import script from "./UserAccountDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserAccountDetail.vue?vue&type=style&index=0&id=31add29e&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31add29e"]])

export default __exports__